import React from 'react';
import { InputNumber  } from "primereact/inputnumber";
import '../css/Form.css'
import useFormError from '../../hooks/useFormError';

const ProInputNumber = ({ id, labelText, value, rowCount = 1, style = { width: '100%' }, onChange, headerText, formik = {}, error, required, disabled= false, minValue = 0  }) => {
  const getFormErrorMessage = useFormError(formik);
  const placeholderText = required?<label htmlFor="inputtext">{labelText}</label>: <label htmlFor="inputtext">{labelText}<span style={{fontSize:11}}>  (optional)</span></label>
  return (
    <div>
    <div className={"p-field " + (+rowCount === 2 ? "p-col-6" : "p-col-12")}  >
      {
        headerText &&
        <div className="p-d-flex p-jc-start">
          <h6 className="form-header">{headerText}</h6>
        </div>
      }
      <span className="p-float-label">
        <InputNumber id={id} style={{ ...style }} value={value} onValueChange={onChange} min={minValue} max={2147483647} disabled={disabled} />      
        {placeholderText}
      </span>     
    </div>
    <div>
      {getFormErrorMessage && getFormErrorMessage(error)}
      </div>
    </div>

  )
}

export default ProInputNumber;